import Domain from 'helpers/Domain';
import HttpService from 'services/HttpService';
import { ACCOUNT_XHR_BASE_PATH } from 'vue/constants/svodRoutes';

export default {
    namespaced: true,

    state: {
        saved: {
            on: null,
            pin: ['', '', '', ''],
            rating: null,
            lockLiveTV: null,
            requirePinSwitchProfileEnabled: null,
            requirePinToWatchContent: null,
            hasPin: false,
        },
        ratingEnabled: true,
    },

    mutations: {
        setSaved(state, saved) {
            state.saved = saved;
        },
        setRatingEnabled(state, payload) {
            state.ratingEnabled = payload;
        },
    },

    getters: {
        ratingGroups(state, getters, rootState, rootGetters) {
            let settings = rootGetters.getServerDataByKey('parentalControlSettings');

            if (settings && settings.parentalControlGroups) {
                return settings.parentalControlGroups.on;
            }
            return null;
        },

        offRating(state, getters, rootState, rootGetters) {
            let settings = rootGetters.getServerDataByKey('parentalControlSettings');

            if (settings && settings.parentalControlGroups) {
                return settings.parentalControlGroups.off;
            }

            return null;
        },

        baselineRating(state, getters, rootState, rootGetters) {
            let settings = rootGetters.getServerDataByKey('parentalControlSettings');

            if (settings && settings.parentalControlGroups) {
                return settings.parentalControlGroups.baseline;
            }

            return null;
        },

        isProfileSwitchEnabled(state) {
            return state.saved.requirePinSwitchProfileEnabled;
        },

        areOn(state) {
            return state.saved.on === true;
        },

        requirePinSwitchProfileEnabled(state) {
            return state.saved.requirePinSwitchProfileEnabled;
        },

        hasPin(state) {
            return state.saved.hasPin;
        },
    },

    actions: {
        loadServerData({ commit, rootGetters, getters }) {
            let parentalSettings = rootGetters.getServerDataByKey('parentalControlSettings');

            if (parentalSettings) {
                commit('setSaved', {
                    on: parentalSettings.parentalControlOn,
                    pin: ['', '', '', ''],
                    rating: parentalSettings.userParentalControlLevel,
                    lockLiveTV: parentalSettings.lockLiveTV,
                    requirePinToWatchContent:
                        parentalSettings.userParentalControlLevel !== getters['offRating'],
                    requirePinSwitchProfileEnabled: parentalSettings.requirePinSwitchProfileEnabled,
                    hasPin: parentalSettings.hasPin,
                });
            }
        },

        /**
         * @returns {Promise<unknown>}
         */
        setParentalControlsOn({ commit, rootGetters, getters }, payload) {
            let http = new HttpService();
            let prefix = CBS.Registry.region.prefix;

            let params = Object.assign({}, payload);

            if (payload.pin) {
                params.pin = payload.pin.join('');
            }

            if (false === payload.requirePinToWatchContent) {
                params.rating = getters['offRating'];
            }

            if (false === payload.requirePinToWatchContent) {
                params.rating = getters['offRating'];
            }

            if (false === payload.requirePinToWatchContent) {
                params.rating = getters['offRating'];
            }

            params.tk_trp = rootGetters.getServerDataByKey('authToken');

            return http
                .doPost(`${prefix}${ACCOUNT_XHR_BASE_PATH}set-parental-controls/`, params)
                .then((res) => {
                    payload.on = true;
                    commit('setSaved', {
                        ...payload,
                        hasPin: true,
                    });

                    return res;
                });
        },

        /**
         * @returns {Promise<unknown>}
         */
        setParentalControlsOff({ getters, commit, rootGetters }) {
            let http = new HttpService();
            let prefix = CBS.Registry.region.prefix;

            let params = {
                rating: getters['offRating'],
                lockLiveTV: false,
                requirePinSwitchProfileEnabled: false,
                tk_trp: rootGetters.getServerDataByKey('authToken'),
            };

            // set-parental-controls-off is the endpoint for US and for INTL user without pin
            const endpoint =
                Domain.isInternational() && getters['hasPin']
                    ? 'set-parental-controls'
                    : 'set-parental-controls-off';

            return http
                .doPost(`${prefix}${ACCOUNT_XHR_BASE_PATH}${endpoint}/`, params)
                .then((res) => {
                    commit('setSaved', {
                        on: false,
                        pin: ['', '', '', ''],
                        rating: params.rating,
                        lockLiveTV: params.lockLiveTV,
                        requirePinSwitchProfileEnabled: false,
                        requirePinToWatchContent: false,
                        hasPin: false,
                    });

                    return res;
                });
        },

        /**
         * @returns {Promise<unknown>}
         */
        relogin({ commit, state, rootGetters }, payload) {
            let http = new HttpService();
            let prefix = CBS.Registry.region.prefix;

            payload.tk_trp = rootGetters.getServerDataByKey('authToken');

            return http
                .doPost(`${prefix}${ACCOUNT_XHR_BASE_PATH}parental-relogin/`, payload)
                .then((res) => {
                    if (state.saved.on && res.data?.pin) {
                        let saved = Object.assign({}, state.saved, {
                            pin: res.data.pin.split(''),
                            hasPin: true,
                        });

                        commit('setSaved', saved);
                    }

                    return res;
                });
        },
    },
};
